<!-- Translated: yes -->
<template>
  <component :is="params.componentType || 'Modal'" set-class="no-padding" @close="closeTheModal" :clickOutside="clickOutside">
    <div slot="header">
      <div class="modal-header">
      </div>
    </div>
    <div :class="{'modal-content': true, disabled: (!open && !params.allowPrevious)}">
      <div class="datepicker-modal-content notranslate">
        <div class="datepicker">
          <div class="heading" v-if="!theStartDate || params.startDateOnly">{{ $t('general.pick-startdate') }}</div>
          <div class="heading" v-else>{{ $t('general.pick-enddate') }}</div>
          <Datepicker :type="params.type" ref="pickerDate" :validDate="validStartDate" :validRangeDate="validRangeDate" @change="changedStartDate" @change-end="changedEndDate" :value="startDate" :value-end="endDate" :range="selectRange" :select-range="selectRange" :allow-previous="params.allowPrevious" :disabledDays="getDisabledDays" :specialDays="getSpecialDays" :startMonth="params.startMonth" :showAllMonths="params.showAllMonths" @month-change="updateMonth" />
          <div class="footer green" v-if="infoMessage">
            <div class="info" v-if="infoMessage !== '-'">
              <icon name="info-blue" :scale="1.5" />
              <span>Första tillgängliga tid för hämtning av liftkort denna dag är <b>{{infoMessage}}</b></span>
            </div>
            <div class="info" v-if="infoMessage === '-'">
              <icon name="info-blue" :scale="1.5" />
              <span>Det finns inga tider kvar denna dag</span>
            </div>
          </div>
          <div class="footer" v-if="isSummerSeason">
            <div class="info info--big">
              <div v-if="SITE_CONFIG.accomodations.date_picker_help.summer_title">
                <icon name="info-blue" :scale="1.5" />
                <span><strong v-html="SITE_CONFIG.accomodations.date_picker_help.summer_title"></strong></span>
              </div>
              <div v-if="SITE_CONFIG.accomodations.date_picker_help.summer_info1">
                <span v-html="SITE_CONFIG.accomodations.date_picker_help.summer_info1"></span>
              </div>
              <div>
                <div v-if="SITE_CONFIG.accomodations.date_picker_help.summer_info2" style="width: 1.5em;height: 1.5em;background-color: #005580;border-radius: 50%;vertical-align: middle;display:inline-block;margin-right:10px;"></div>
                <span v-html="SITE_CONFIG.accomodations.date_picker_help.summer_info2"></span>
              </div>
              <div>
                <div v-if="SITE_CONFIG.accomodations.date_picker_help.summer_info3" style="width: 1.5em;height: 1.5em;background-color: #bfd9e1;border-radius: 50%;vertical-align: middle;display:inline-block;margin-right:10px;"></div>
                <span v-html="SITE_CONFIG.accomodations.date_picker_help.summer_info3"></span>
              </div>
              <div v-if="SITE_CONFIG.accomodations.date_picker_help.summer_info4">
                <span v-html="SITE_CONFIG.accomodations.date_picker_help.summer_info4"></span>
              </div>
            </div>
          </div>
          <div class="footer green" v-if="params.extraInfo && params.extraInfo(theStartDate, theEndDate)[0]">
            <div class="info">
              <icon name="info-blue" :scale="1.5" />
              <span v-html="params.extraInfo(theStartDate, theEndDate)[0]"></span>
            </div>
          </div>
          <div class="footer">
            <div class="info" v-if="theStartDate && selectRange" style="margin-bottom:10px;">
              <icon name="info-blue" :scale="1.5" />
              <span v-html="params.infoOnPicked ? params.infoOnPicked : (params.disableSingle ? 'Du måste boka minst två dagar' : $t('skirental.pick-enddate'))"></span>
            </div>
            <div v-show="theStartDate && !theEndDate && !params.disableSingle">
              <span v-if="selectRange">
                <button @click="selectDate()" class="datepicker-bt block" v-if="showNight" style="margin-bottom:6px;">{{ $t('skirental.day-options.day') }} {{theStartDate | date}}</button>
                <button @click="selectNight()" class="datepicker-bt block" v-if="showNight">{{
                  SITE_CONFIG.site === 'vallasen'
                    ? $t('skirental.day-options.night')
                    : (SITE_CONFIG.site === 'ulricehamn'
                      ? ($t('skirental.day-options.hours', {hours: SITE_CONFIG.rental.night_hours}) + '/' + $t('general.night'))
                      : $t('skirental.day-options.night')
                    )
                }} {{theStartDate | date}}</button>
                <button @click="selectDate()" class="datepicker-bt block" v-if="!showNight">{{ $t('skirental.day-options.one-day') }} {{theStartDate | date}}</button>
              </span>
              <button @click="selectDate()" class="datepicker-bt block" v-if="!selectRange">{{params.terminology ? params.terminology : $t('general.cta.book')}}</button>
            </div>
            <!--<button class="datepicker-bt" v-show="theStartDate && !selectRange && !theEndDate" @click="pickEndDate()">Välj slutdatum</button>-->
            <button class="datepicker-bt" v-show="theStartDate && !selectRange && theEndDate" @click="chooseDates('day')">{{params.terminology ? params.terminology : $t('general.cta.book')}}
              <span v-if="params.type === 'skiletting' && hasClosedDays">
                {{ numberOfDays }}
              </span>
              <span v-else>
                {{[theStartDate, theEndDate] | dateRange}}
              </span>
            </button>
            <div class="width-limit">
              <div class="info" v-if="!theStartDate">
                <icon name="info-blue" :scale="1.5" />
                <span v-html="params.info ? params.info : $t('skirental.departure-usage-info')"></span>
              </div>
            </div>
          </div>
          <div class="footer" v-if="params.extraInfo && params.extraInfo(theStartDate, theEndDate)[4]">
            <div class="info">
              <icon name="info-blue" :scale="1.5" />
              <span v-html="params.extraInfo(theStartDate, theEndDate)[4]"></span>
            </div>
          </div>
          <div class="footer green" v-if="params.extraInfo && params.extraInfo(theStartDate, theEndDate)[3]">
            <div class="info">
              <icon name="info-blue" :scale="1.5" />
              <span v-html="params.extraInfo(theStartDate, theEndDate)[3]"></span>
            </div>
          </div>
          <div class="footer" v-if="params.extraInfo && params.extraInfo(theStartDate, theEndDate)[2]">
            <div class="info">
              <icon name="info-blue" :scale="1.5" />
              <span v-html="params.extraInfo(theStartDate, theEndDate)[2]"></span>
            </div>
          </div>
          <div class="footer green" v-if="params.extraInfo && params.extraInfo(theStartDate, theEndDate)[1]">
            <div class="info">
              <icon name="info-blue" :scale="1.5" />
              <span v-html="params.extraInfo(theStartDate, theEndDate)[1]"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="overlay-no-dates" v-if="!open && !params.allowPrevious">
      <p v-html="closedMessage"></p>

      <button @click="closeTheModal()">{{ $t('general.okay') }}</button>
    </div>
  </component>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import ModalFaker from '@/components/components/ModalFaker';
import Datepicker from '@/components/components/Datepicker';
import {
  validStartDate,
  validRangeDate,
  // validEndDate,
} from '@/dates';
import {
  dayCountExcludeClosed,
} from '@/lib';
import API from '@/classes/API';

import moment from 'moment';
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/css/vue-popper.css';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    popper: Popper,
    Datepicker,
    ModalFaker,
  },
  data() {
    return {
      validStartDates: [],
      validEndDates: [],
      disabledEndDates: [],
      disabledDays: [],
      specialDays: [],
      theStartDate: null,
      theEndDate: null,
      selectRange: false,
      infoMessage: '',
      isSummerSeason: false,
      disableRange: false,
    };
  },
  async mounted() {
    this.loaded = true;
    this.validStartDates = this.params.validDates;
    this.validEndDates = this.params.validDates;
    this.disabledDays = this.params.disabledDays;
    this.specialDays = this.params.specialDays;

    if (typeof this.params.disableRange === 'boolean') {
      this.disableRange = this.params.disableRange;
    }

    if (this.params.pickedStartDate) {
      this.theStartDate = this.params.pickedStartDate;
      this.$refs.pickerDate.currentMonth = moment(this.params.pickedStartDate).startOf('month').toDate();
      this.selectRange = !this.disableRange;
    } else {
      this.$refs.pickerDate.currentMonth = moment(this.validStartDates[0]).startOf('month').toDate();
    }
    if (this.params.pickedEndDate) {
      this.theEndDate = this.params.pickedEndDate;
      this.selectRange = false;
    }
  },
  computed: {
    closedMessage() {
      return this.params.closed_message || this.SITE_CONFIG.closed_message || this.$i18n.t('general.closed-backup');
    },
    open() {
      if (typeof this.params.open !== 'undefined') {
        return this.params.open;
      }
      return this.SITE_CONFIG.is_open;
    },
    startDate() {
      return (
        this.theStartDate
        && new Date(this.theStartDate)
      );
    },
    endDate() {
      return (
        this.theEndDate
        && new Date(this.theEndDate)
      );
    },
    validStartDate() {
      return validStartDate({
        validStartDates: this.validStartDates,
      });
    },
    validRangeDate() {
      if (this.validEndDates && this.validEndDates.length) {
        return validStartDate({
          validStartDates: this.validEndDates,
        });
      }
      return validRangeDate({
        startDate: this.startDate,
        validStartDates: this.validStartDates,
        days: (this.validEndDates || 1),
      });
    },
    showNight() {
      const ymd = moment(this.startDate).format('YYYY-MM-DD');
      if (this.params.night && this.params.night.length && this.params.night.indexOf(ymd) !== -1) {
        return true;
      }
      return false;
    },
    hasClosedDays() {
      return true;
    },
    numberOfDays() {
      const diff = dayCountExcludeClosed(this.startDate, this.endDate);
      const days = this.$i18n.t('general.days');

      if (diff > 1) {
        return `${diff} ${days}`;
      }

      return diff;
    },
    getDisabledDays() {
      if (this.theStartDate && !this.theEndDate) {
        return this.disabledEndDates;
      }
      return this.disabledDays;
    },
    getSpecialDays() {
      return this.specialDays;
    },
    clickOutside() {
      if (typeof this.params.clickOutside === 'undefined') {
        return true;
      }

      return this.params.clickOutside;
    },
  },
  methods: {
    ...mapMutations([
      'setAccomodationsFilterStartDate',
      'setAccomodationsFilterEndDate',
      'setAccomodationsAvailableIds',
      'closeModal',
    ]),
    selectDate() {
      this.selectRange = !this.disableRange;
      this.chooseDates('day');
    },
    selectNight() {
      this.selectRange = !this.disableRange;
      this.chooseDates('night');
    },
    pickEndDate() {
      this.selectRange = !this.disableRange;
    },
    closeTheModal() {
      this.params.onClose(null, null, null, null);
      this.closeModal();
    },
    chooseDates(type) {
      if (this.params.onClose) {
        this.params.onClose(this.theStartDate, this.theEndDate, type, this.isSummerSeason);
      }
      this.closeModal();
    },
    async updateAvailableUnits(value) {
      const startFormatted = moment(this.startDate).format('YYYY-MM-DD');
      const endFormatted = moment(value).format('YYYY-MM-DD');
      const { data } = await API.get(`/dates/units-available/${startFormatted}/${endFormatted}`);
      this.setAccomodationsAvailableIds(data);
    },
    async changedStartDate(value) {
      let dates = {};

      this.theStartDate = value;
      if (this.params.startDateOnly) {
        this.selectRange = false;
      } else {
        this.selectRange = !this.disableRange;
      }

      if (this.params.onPickStart) {
        dates = await this.params.onPickStart(value);

        if (dates instanceof Array) {
          this.validEndDates = dates;
        } else if (Number.isInteger(dates)) {
          this.validEndDates = dates;
        } else if (!dates) {
          this.validEndDates = dates;
        } else {
          this.validEndDates = dates.valid;
          this.disabledEndDates = dates.invalid;
        }
      }

      if (!this.params.startDateOnly) {
        this.$refs.pickerDate.updateMonth();
      }

      if (this.params.onPickStartInfo) {
        this.infoMessage = await this.params.onPickStartInfo(value);
        if (this.infoMessage.time) {
          this.infoMessage = this.infoMessage.time;
        }
      }
    },
    changedEndDate(value) {
      this.theEndDate = value;
      this.selectRange = false;
      if (this.theStartDate && !this.theEndDate) {
        if (!this.params.startDateOnly) {
          this.selectRange = !this.disableRange;
        }
      }
      /* this.updateAvailableUnits(value);
      this.setAccomodationsFilterEndDate(value);
      this.closeModal(); */
    },
    updateMonth(e) {
      const month = moment(e.month);

      if (month.get('month') >= 4 && month.get('month') <= 10) {
        this.isSummerSeason = true;
      } else {
        this.isSummerSeason = false;
      }
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.popper
  border-radius 2px
  background-color #262626
  font-family Interstate
  font-size 12px
  font-weight 300
  color #ffffff
  padding 12px
  box-shadow none
  border 0
  text-align left

.disabled
  disabled-grey(0.1)

.datepicker-modal-content
  display flex
  justify-content: center;
  //margin -space-2
  .datepicker
    width 100%
    margin-left auto
    margin-right auto
    .datepicker
      margin-bottom 15px

.heading
  font-weight bold
  text-transform uppercase
  margin-top 5px
  margin-bottom 0
  text-align center
  padding 15px

.divider
  background silver-light
  width 4px

.footer
  padding 15px 30px
  background-color #ecf5f8
  text-align: center
  border-bottom-left-radius: 2px
  border-bottom-right-radius: 2px
  &.green
    border-radius 2px
    background-color rgba(199, 220, 183, 0.26)
    border solid 1px #d1e0c2
    padding 15px 27px
    // margin-top: 15px
    margin-bottom 0
    max-width 100%

.width-limit
  +max-mobile()
    max-width 100%
  +min-tablet()
    padding-left: calc(50% - 170px);
    padding-right: calc(50% - 170px);

.info
  font-size 12px
  font-weight bold
  display flex
  max-width 320px
  text-align: left
  line-height: 1.2em
  .icon
    margin-right 10px
  span
    max-width 90%
  &.info--big
    font-weight normal
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
    & > div
      margin-bottom 15px

.overlay-no-dates
  font-size 18px
  position absolute
  width 100%
  padding-left 25px
  padding-right 25px
  top: 35%
  text-align: center
  margin 0 auto
  line-height: 1.3
</style>



// WEBPACK FOOTER //
// DatepickerRangeModal.vue?4a7da31e